import profile from './admin.jpg'

export const assets ={
    
    profile

}